import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Grid, Header, Button, Modal, Icon, Message,
} from 'semantic-ui-react';

class PendingGuaranteeDetails extends Component {
  render() {
    const {
      pendingGuarantee: {
        guaranteePrice,
        purchasePrice,
        vehicleFullDescription,
        pendingComments,
        vehicleInformation: { odometerReading, vin },
        auctionInformation: { locationInitials, laneNumber, runNumber },
      },
      isDetailsModalOpen,
      onCloseHandler,
      invalidatePendingGuarantee,
      allowPendingGuarantee,
      error,
      submitting,
    } = this.props;

    return (
      <div>
        <Modal
          open={isDetailsModalOpen}
          closeIcon
          onClose={onCloseHandler}
          closeOnEscape={false}
          closeOnRootNodeClick={false}
        >
          <Modal.Header>Pending Offer Details</Modal.Header>
          <Modal.Content image scrolling>
            <Modal.Description>
              {error && (
                <Message negative>
                  <p>{error}</p>
                </Message>
              )}
              <Grid columns={2}>
                <Grid.Row>
                  <Grid.Column>
                    <Header size='tiny'>Price:</Header>
                  </Grid.Column>
                  <Grid.Column>{guaranteePrice}</Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column>
                    <Header size='tiny'>Location:</Header>
                  </Grid.Column>
                  <Grid.Column>{locationInitials}</Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column>
                    <Header size='tiny'>Lane-Run:</Header>
                  </Grid.Column>
                  <Grid.Column>
                    {laneNumber} - {runNumber}
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column>
                    <Header size='tiny'>Vehicle Purchase Price:</Header>
                  </Grid.Column>
                  <Grid.Column>{purchasePrice}</Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column>
                    <Header size='tiny'>Vehicle:</Header>
                  </Grid.Column>
                  <Grid.Column>
                    {vehicleFullDescription},
                    {odometerReading} miles, VIN {vin}
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column>
                    <Header size='tiny'>Comments:</Header>
                  </Grid.Column>
                  <Grid.Column>{pendingComments}</Grid.Column>
                </Grid.Row>
              </Grid>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            {submitting && (
              <Button loading positive>
                Submitting...
              </Button>
            )}
            {!submitting && (
              <Button
                color='green'
                onClick={invalidatePendingGuarantee}
                inverted
              >
                <Icon name='checkmark' /> Invalidate
              </Button>
            )}
            {!submitting && (
              <Button color='green' onClick={allowPendingGuarantee} inverted>
                <Icon name='checkmark' /> Allow
              </Button>
            )}

            <Button onClick={onCloseHandler}>Cancel</Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

PendingGuaranteeDetails.propTypes = {
  pendingGuarantee: PropTypes.shape({
    guaranteePrice: PropTypes.string,
    purchasePrice: PropTypes.string,
    vehicleFullDescription: PropTypes.string,
    pendingComments: PropTypes.string,
    vehicleInformation: PropTypes.shape({
      odometerReading: PropTypes.number,
      vin: PropTypes.string,
    }),
    auctionInformation: PropTypes.shape({
      locationInitials: PropTypes.string,
      laneNumber: PropTypes.string,
      runNumber: PropTypes.string,
    }),
  }).isRequired,
  isDetailsModalOpen: PropTypes.bool.isRequired,
  onCloseHandler: PropTypes.func.isRequired,
  invalidatePendingGuarantee: PropTypes.func.isRequired,
  allowPendingGuarantee: PropTypes.func.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
};

export default PendingGuaranteeDetails;
